import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-blue-900 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="mb-6">
          <AlertCircle className="w-24 h-24 text-red-500 mx-auto mb-4" />
          <h1 className="text-6xl font-extrabold text-white mb-2">404</h1>
          <p className="text-2xl font-bold text-red-400">Halaman Tidak Ditemukan</p>
        </div>
        
        <p className="text-gray-300 mb-8 text-lg">
          Maaf, halaman yang Anda cari tidak tersedia. Silahkan kembali ke halaman utama atau navigasi menggunakan menu di sebelah.
        </p>

        <div className="flex gap-4 flex-col sm:flex-row justify-center">
          <button
            onClick={() => navigate('/admin/dashboard')}
            className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
          >
            Kembali ke Dashboard
          </button>
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-gray-700 text-white font-semibold rounded-lg hover:bg-gray-600 transition-colors"
          >
            Kembali
          </button>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-700">
          <p className="text-gray-400 text-sm mb-4">Status: 404 Not Found</p>
          <p className="text-gray-500 text-xs">
            Jika Anda yakin ini adalah kesalahan, silahkan hubungi administrator.
          </p>
        </div>
      </div>
    </div>
  );
}
